module.exports = __webpack_public_path__ + "static/media/dorme.33091713.JPG";